import { render, staticRenderFns } from "./McStatusChip.vue?vue&type=template&id=5c7072a3"
import script from "./McStatusChip.vue?vue&type=script&lang=js"
export * from "./McStatusChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports